// --- SaniQ ---
import * as SurveysConstants from '../constants';

const initialState = {
  collection: [],
  isFetching: false,
  hasLoaded: false
};

export function surveys(state = initialState, action) {
  switch (action.type) {
    case SurveysConstants.PATIENT_SURVEYS_FETCH_STARTED:
      return {...state, isFetching: true, hasLoaded: false};
    case SurveysConstants.PATIENT_SURVEYS_FETCH_COMPLETED:
      return {
        ...state,
        collection: action.surveys,
        isFetching: false,
        hasLoaded: true
      };
    default:
      return state;
  }
}
